<template>
  <div class="row">
    <div class="col-sm-12 table-responsive p-x-0">
      <table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped dataTable">
        <thead>
        <tr role="row">
          <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">#</th>
          <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">菜單(ID)</th>
          <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">狀態</th>
          <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">上架時間</th>
          <th></th>
          <!--<th v-if="path == 'upScheduleAll'"><input type="checkbox" v-model="toggleChecked"></th>-->
        </tr>
        </thead>
        <tbody>
        <tr class="even" role="row" v-for="(m, index) in menuList">
          <td class="sorting_1">
            {{index + 1}}
          </td>
          <td>{{m.menu_name}} ({{m.menu_id}})</td>
          <td>{{m.status}}</td>
          <td>{{m.start_time}} ~ {{m.end_time}}</td>
          <td>
            <button class="btn btn-default" @click="editStores(s.menu_id, s.store_id)"><i class="fa fa-pencil" aria-hidden="true"></i></button>
          </td>
          <!--<td v-if="path == 'upScheduleAll' || path == 'upScheduleOne'">-->
            <!--<span class="checkbox-enable" v-if="storeList.length != 1">-->
              <!--<input type="checkbox" checked :id="index" :value="index" v-model="checkStores">-->
            <!--</span>-->
            <!--<button v-if="storeList.length == 1" class="btn btn-default"><i class="fa fa-trash" aria-hidden="true"></i></button>-->
          <!--</td>-->
        </tr>
        </tbody>
      </table>
    </div>
    <div class="col-xs-12 text-center" v-if="path != 'upScheduleAll' && path != 'upScheduleOne'">
      <ul class="pagination">
        <li class="paginate_button" v-for="index in 5" :class="{active: isActive(index)}" @click="clickPage(index)">
          <a class="c-pointer">{{index}}</a>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default{
  props: {
    storeList: {
      type: Array
    }
  },
  data () {
    return {
      msg: 'hello vue',
      path: this.$route.name,
      newList: [],
      tableIndex: 1,
      checkStores: [0, 1],
      toggleChecked: true,
      count: 10,
      menuList: [
        {'store_id': 1, 'start_time': '2017-04-24 08:00:00', 'end_time': '2017-06-01 00:00:00', 'status': 1, 'update_time': '2017-01-14 16:09:16', 'create_time': '2017-01-14 16:09:16', 'schedule_id': 122, 'menu_id': 1, 'menu_name': '夏日菜單'},
        {'store_id': 3, 'start_time': '2017-04-24 08:00:00', 'end_time': '2017-06-01 00:00:00', 'status': 1, 'update_time': '2017-01-14 16:09:16', 'create_time': '2017-01-14 16:09:16', 'schedule_id': 124, 'menu_id': 3, 'menu_name': '冬季菜單'}
      ]
      // storeList: [ { 'store_id': 1, 'start_time': '2017-04-24 08:00:00', 'end_time': '2017-06-01 00:00:00', 'status': 1, 'update_time': '2017-01-14 16:09:16', 'create_time': '2017-01-14 16:09:16', 'schedule_id': 122, 'menu_id': 1 }, { 'store_id': 3, 'start_time': '2017-04-24 08:00:00', 'end_time': '2017-06-01 00:00:00', 'status': 1, 'update_time': '2017-01-14 16:09:16', 'create_time': '2017-01-14 16:09:16', 'schedule_id': 124, 'menu_id': 1 } ]
    }
  },
  methods: {
    isActive (index) {
      if (this.tableIndex === index) return true
      else return false
    },
    editStores (menuId, storeId) {
      this.$router.push('/upSchedule/' + storeId + '/' + menuId)
    },
    changeTime (type) {
      for (var key in this.newList) {
        if (type === 's') this.newList[key].start_time = this.getMenuStartTime
        if (type === 'e') this.newList[key].end_time = this.getMenuEndTime
      }
    },
    clickPage (index) {
      this.tableIndex = index
      this.$emit('getIndex', index)
    }
  },
  computed: {
    ...mapGetters(['getMenuStartTime', 'getMenuEndTime'])
  },
  created () {
    this.newList = this.storeList
  },
  watch: {
    getMenuStartTime () {
      this.changeTime('s')
    },
    getMenuEndTime () {
      this.changeTime('e')
    },
    toggleChecked () {
      if (this.toggleChecked) {
        this.checkStores = [0, 1]
      } else {
        this.checkStores = []
      }
    },
    checkStores () {
      if (!this.checkStores.length) this.toggleChecked = false
      else if (this.checkStores.length === 2) this.toggleChecked = true
    }
  }
}
</script>



// WEBPACK FOOTER //
// StoreScheduleListTemp.vue?7661f846